<dashboardnav>
  <cradua-licence-status [licencestatuss]="licencestatuss$ | async" (licencestatus)="onSubmitLicenceStatus($event)"
    (deleteLicenceStatusEvent)="onDeleteLicenceStatus($event)" *ngIf="(isLoadingLicenceStatus$ | async ) === false">
  </cradua-licence-status>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingLicenceStatus$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
